import enRaw from './locales/en.json';
import ruRaw from './locales/ru.json';

type LocaleData = Record<string, string>;

const en: LocaleData = enRaw;
const ru: LocaleData = ruRaw;

const locales: Record<string, LocaleData> = { en, ru };
let current: LocaleData = en;
let currentLang = 'en';

export function setLocale(lang: string): void {
  const loc = locales[lang];
  if (loc) {
    current = loc;
    currentLang = lang;
  }
}

export function getLocale(): string {
  return currentLang;
}

export function t(key: string, params?: Record<string, string | number>): string {
  let str = current[key] ?? en[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      str = str.replace(`{${k}}`, String(v));
    }
  }
  return str;
}

export function registerLocale(lang: string, data: LocaleData): void {
  locales[lang] = { ...(locales[lang] ?? {}), ...data };
}
